import styles from "./table.module.scss";

const WeddingSchedule = () => {
  const schedule = [
    { time: "12:00 PM", activity: "Guests Arrival" },
    { time: "12:30 PM", activity: "Ceremony Begins" },
    { time: "1:30 PM", activity: "Cocktail Hour" },
    { time: "3:00 PM", activity: "Reception Starts" },
    { time: "6:00 PM", activity: "Dinner & Speeches" },
    { time: "8:00 PM", activity: "First Dance" },
    { time: "9:00 PM", activity: "Cake Cutting" },
    { time: "10:00 PM", activity: "Dance Party" },
    { time: "12:00 AM", activity: "Farewell" },
  ];

  return (
    <div className={styles.schedule}>
      <h2>Wedding Day Plan</h2>
      <table>
        <thead>
          <tr>
            <th>Time</th>
            <th>Activity</th>
          </tr>
        </thead>
        <tbody>
          {schedule.map((item, index) => (
            <tr key={index}>
              <td>{item.time}</td>
              <td>{item.activity}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WeddingSchedule;
